// @flow

import { sortBy, assign } from 'lodash';
import { getOrder } from '../../../HttpRequests/orders';
import { loadOrder } from '../State/order';
import { setFetching } from '../State/fetching';
import { getProps } from '../props';
import handleException from '../../../Core/Helpers/handleException';

export default () => async (dispatch: Function) => {

  try {

    const { id } = getProps().match.params;

    const params = {};

    params.include = [
      'project',
      'project.clientSite',
      'project.clientSite.client',
      'orderGroups',
      'orderGroups.orderItems',
      'orderCaveats',
      'clientContact',
      'user',
      'estimate',
      'media',
    ].join();

    params.append = [
      'action_statuses',
      'updatable_fields'
    ].join();

    dispatch(setFetching(true));

    console.log('[OrderView fetchOrder] Fetching order with params:', { id, includes: params.include });
    const response = await getOrder({ id, params });

    const order = response.data.data;
    console.log('[OrderView fetchOrder] Order fetched:', {
      orderId: order.id,
      hasProject: !!order.project,
      hasClientSite: !!(order.project && order.project.client_site),
      hasClient: !!(order.project && order.project.client_site && order.project.client_site.client),
      clientSiteKeys: order.project && order.project.client_site ? Object.keys(order.project.client_site) : [],
      clientKeys: order.project && order.project.client_site && order.project.client_site.client ? Object.keys(order.project.client_site.client) : []
    });

    order.order_groups = sortBy(
      order.order_groups.map(orderGroup => assign(
        {},
        orderGroup,
        {
          order_items: sortBy(
            orderGroup.order_items.map(item => ({
              ...item,
              type: item.type || 'none'
            })),
            'order_number'
          )
        }
      )
    ), 'order_number');

    order.order_optionals = sortBy(order.order_optionals, 'order_number');

    order.order_caveats = sortBy(order.order_caveats, 'order_number');

    dispatch(loadOrder(order));

    dispatch(setFetching(false));

  } catch (error) {

    handleException(error);

  }
}
